import { StepperConfig } from '@ntv360/component-pantry';

export const DEFAULT_STEPPER_CONFIG: StepperConfig = {
    variant: 'vertical-reverse',
    stepperColor: 'accent',
    labelColor: 'white',
    descriptionColor: 'neutral',
    showLabels: true,
    showDescriptions: true,
    clickable: true,
    allowSkipping: true,
};

export const SUB_STEPPER_CONFIG: StepperConfig = {
    variant: 'default',
    stepperColor: 'accent',
    labelColor: 'neutral-dark',
    showLabels: true,
    showDescriptions: true,
    clickable: true,
    allowSkipping: false,
};

/**
 * Type for stepper configurations
 */
export type StepperConfigs = {
    default: StepperConfig;
    compact: StepperConfig;
    sub: StepperConfig;
    interactive: StepperConfig;
};

// Additional stepper configurations for different use cases
export const STEPPER_CONFIGS: StepperConfigs = {
    default: DEFAULT_STEPPER_CONFIG,
    compact: {
        ...DEFAULT_STEPPER_CONFIG,
        showDescriptions: false,
    },
    sub: SUB_STEPPER_CONFIG,
    interactive: {
        ...DEFAULT_STEPPER_CONFIG,
        clickable: true,
    },
};
